import React from 'react';
import DataTableCard from '../../../../components/ui/DataTableCard';
import { useFetchList } from '../../../../hooks/useFetchList';

const COLUMNS = [
  { field: 'firstName', header: 'First name' },
  { field: 'lastName', header: 'Last name' },
  { field: 'emailAddress', header: 'Email' },
  { field: 'phoneNumber', header: 'Phone number' },
];

const ApproveLoansTable = () => {
  const { rows } = useFetchList('users');

  return (
    <DataTableCard
      title="All User Profiles Report"
      exportName="All Users"
      columns={COLUMNS}
      rows={rows}
      emptyMessage="No Users found"
    />
  );
};

export default ApproveLoansTable;
